import { Icon } from "@chakra-ui/icons"
import React from "react"

const FacebookIcon = props => {
  return (
    <Icon viewBox="0 0 31.5 31.5" {...props}>
      <g>
        <path
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          d="M.75.75h30v30h-30z"
        />
        <path
          d="M19 13.61h-2v-1.37c.15-1.3 2.29-1.05 2.29-1.05V9c-.07 0-4.26-1-5.1 2.18a15.28 15.28 0 00-.19 2.43h-1.76v2.45h1.9v6.64h2.76v-6.64H19l.24-2.45H19"
          fill="currentColor"
        />
      </g>
    </Icon>
  )
}

export default FacebookIcon
